import { render, staticRenderFns } from "./PayphoneProccess.vue?vue&type=template&id=2e288260&scoped=true"
import script from "./PayphoneProccess.vue?vue&type=script&lang=js"
export * from "./PayphoneProccess.vue?vue&type=script&lang=js"
import style0 from "./PayphoneProccess.vue?vue&type=style&index=0&id=2e288260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e288260",
  null
  
)

export default component.exports